import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewCourseMutation } from "./coursesApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"

const NewCourseForm = () => {
    const {groupId, type} = useParams()
    const [addNewCourse, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewCourseMutation()

    const navigate = useNavigate()

    const [name, setName] = useState('')
    const [active, setActive] = useState(true)

    useEffect(() => {
        if (isSuccess) {
            setName('')
            navigate(`/${type}/${groupId}/courses`)
        }
    }, [isSuccess, navigate])

  

    const canSave = [name].every(Boolean) && !isLoading

    const onSaveCourseClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewCourse({ name, active })
        }
    }


    const errClass = isError ? "errmsg" : "offscreen"
    const validTitleClass = !name ? "form__input--incomplete" : ''

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveCourseClicked}>
                <div className="form__title-row">
                    <h2>New Course</h2>
                    <div className="form__action-buttons">
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/courses`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="name">
                    Name:</label>
                <input
                    className={`form__input ${validTitleClass}`}
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    value={name}
                    onChange={e=>setName(e.target.value)}
                />

        <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="course-active">
                            ACTIVE:
                            <input
                                className="form__checkbox"
                                id="course-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={e => setActive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>


               


            </form>
        </>
    )

    return content
}

export default NewCourseForm